import React from 'react';

const FormRenderContext = React.createContext(null);

export default FormRenderContext;